import BaseModel, {defineTranslatableProperties} from "../../core/components/input-widget/BaseModel";
import {store} from "@/plugins/vuex";

export default class MiscellaneousItem extends BaseModel {
  amount = null;
  description = null;
  taxable = null;
  vat = null;
  inventory_uuid = null;
  description_dropdown_value = null;

  rules = {};

  attributeLabels = {};

  constructor(data = {}, forceUpdateDropdownData = false) {
    super();
    Object.assign(this, {...data, description_dropdown_value: null});
    this.initTranslatableFields(this);
    let miscellaneousItemCharges = store.state.global.miscellaneousItemCharges
    if (data.uuid || forceUpdateDropdownData) {
      let item = miscellaneousItemCharges.find(item => [item.value].includes(this.description));
      if (item) {
        this.description_dropdown_value = item.value;
      } else {
        this.description_dropdown_value = 'other';
      }
    }
  }

  toJSON() {
    let data = super.toJSON();
    if (data.description_dropdown_value !== 'other') {
      let item = store.state.global.miscellaneousItemCharges.find(item => item.value === data.description_dropdown_value);
      if (item) {
        data.description = item.value;
      }
    }
    delete data.description_dropdown_value;
    return data;
  }
}

// defineTranslatableProperties(MiscellaneousItem);
